import UserControllerBase from '../base'
import type { TResponseBase } from '~/services/MSAPI/types'
import type { NOrganizationCustomization } from './types'

export default class UserControllerOrganizationCustomization extends UserControllerBase {
  static readonly controllerPath = 'organizationcustomization'
  private readonly serviceUrl: string

  constructor() {
    super(UserControllerOrganizationCustomization.controllerPath)
    this.serviceUrl = this.getFullServiceUrl()
  }

  async getOrganizationCustomization(): TResponseBase<NOrganizationCustomization.IGetOrganizationCustomizationResponse> {
    return await useFetchInstance(`${this.serviceUrl}`, {
      method: 'GET',
    })
  }

  async getOrganizationCustomizationById(
    organizationId: string,
  ): TResponseBase<NOrganizationCustomization.IGetOrganizationCustomizationResponse> {
    return await useFetchInstance(`${this.serviceUrl}/${organizationId}`, {
      method: 'GET',
    })
  }

  async createOrganizationCustomization(
    organizationId: string,
    body: FormData,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/${organizationId}`, {
      method: 'POST',
      body,
    })
  }

  async updateOrganizationCustomization(
    organizationId: string,
    body: FormData,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/${organizationId}`, {
      method: 'PATCH',
      body,
    })
  }

  async deleteOrganizationCustomization(
    organizationId: string,
  ): TResponseBase<void> {
    return await useFetchInstance(`${this.serviceUrl}/${organizationId}`, {
      method: 'DELETE',
    })
  }
}
